/**
 * Utility function to get the video path based on quality setting
 * 
 * @param {string} videoName - Base video name (e.g., 'waiting-on-lettuce.mp4')
 * @param {string} quality - Quality level: 'low_quality', 'medium_quality', or 'original'
 * @returns {string} Full path to the video file
 */
export const getVideoPath = (videoName, quality = 'medium_quality') => {
  // Ensure videoName doesn't include path
  const baseName = videoName.replace(/^\/videos\//, '').replace(/^[^/]+\//, '');
  
  // Map quality to folder name (same structure as models)
  const qualityFolder = quality === 'original' ? 'original' : quality;
  
  // Return the full path with quality folder
  return `/videos/${qualityFolder}/${baseName}`;
};

/**
 * Get video path from a full path, replacing with quality folder if needed
 * 
 * @param {string} fullPath - Full path like '/videos/waiting-on-lettuce.mp4' or '/videos/medium_quality/waiting-on-lettuce.mp4'
 * @param {string} quality - Quality level: 'low_quality', 'medium_quality', or 'original'
 * @returns {string} Updated path with quality folder
 */
export const updateVideoPath = (fullPath, quality = 'medium_quality') => {
  // Extract video name from path (handles both /videos/video.mp4 and /videos/quality/video.mp4)
  const match = fullPath.match(/\/videos\/(?:[^/]+\/)?([^/]+\.(mp4|webm|mov|avi|mkv))$/);
  if (!match) {
    // If path doesn't match expected format, return as-is
    return fullPath;
  }
  
  const videoName = match[1];
  return getVideoPath(videoName, quality);
};
